import {
  WITHDRAWAL_LIST,
  WITHDRAWAL_LIST_SUCCESS,
  WITHDRAWAL_LIST_FAILURE,
} from "../../Action/actionTypes";

const INIT_STATE = {
  loading: false,
  withdrawal: [],
};

const withdrawalListReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case WITHDRAWAL_LIST:
      return { ...state, loading: true };
    case WITHDRAWAL_LIST_SUCCESS:
      return {
        ...state,
        withdrawal: action?.payload,
        loading: false,
      };
    case WITHDRAWAL_LIST_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default withdrawalListReducer;
